<template>
    <div class="anchor_mian">
        <div class="anchor_mian_mb" @click="clickMb">

        </div>
        <div class="anchor_con">
            <div class="anchor_tab">
                <div class="anchor_tabli" :class="tabindex == index ? 'anchor_tabact' : ''" v-for="(item, index) in allrealist" :key="index" @click="tabindex = index">
                    {{ item.catname }}
                </div>
            </div>
            <div class="anchor_listcon real_flexDR real_flexWW" v-for="(item, index) in allrealist" :key="index" v-if="tabindex == index">
                <div class="anchor_li" v-for="(item2, index2) in item.list" :key="index2" :class="item2.cover == real_anchor.cover?'choseAnchor':''">
                    <div class="flex_sb">
                        <div class="flex_ali">
                            <img :src="item2.cover" class="anchor_img" />
                            <div>
                                <div class="flexDR">
                                    <p class="anchor_name marR">{{ item2.speakername }}</p>
                                    <div class="online">在线</div>
                                </div>
                                <p class="anchor_desp2">{{item2.fittype}}</p>
                            </div>
                        </div>
                        <p class="anchor_desp fontCR">{{item2.price}}元/百字</p>
                    </div>
                    <!-- <div class="case_btn">展开案例</div> -->
                    <div class="outer">
                        <div class="real_inner">
                            <div class="real_padL20 real_padR20" v-for="item3 in item2.soundinfo">
                                <div class="real_pad real_flexSB">
                                    <div class="real_fontC2 real_fontS14 real_padB16 real_soundName">
                                        <p class="overflow_hide fontS14">{{ item3.soundname }}</p>
                                        <div class="real_flexDR real_flexAC">
                                            <img src="../assets/images/img1/real_label.png" alt="" style="width: 10px; height: 10px; margin-right: 5px" />
                                            <p class="real_fontC1 fontS12">
                                                {{ item3.label }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="real_flexDR">
                                        <div class="real_flexDR real_flexAC real_boxL real_flexJC real_marR10 hover_hand" :class=" demo_audio.audiourl == item3.soundurl ? 'real_boxChose' : '' " @click.stop="playReal(item3.soundurl)">
                                            <img src="../assets/images/pause.png" v-if="demo_audio.audiourl == item3.soundurl" style="width: 15px; height: 15px; margin-right: 5px" />
                                            <img src="../assets/images/play.png" v-else style="width: 15px; height: 15px; margin-right: 5px" />
                                            <span class="fontS14 ">{{demo_audio.audiourl == item3.soundurl ? "暂停" : "试听"}}</span>
                                        </div>
                                        <!-- <router-link to="/real_dubbing"> -->
                                            <div class="real_flexDR real_flexAC real_boxL real_flexJC hover_hand"  :class="item3.soundurl == chose_music.soundurl? 'choseBtn':''">
                                                <img src="../assets/images/play.png" alt="" style="width: 15px; height: 15px; margin-right: 5px" />
                                                <p class="fontS12 " @click="useAnchor(item2,item3)">
                                                    {{item3.soundurl == chose_music.soundurl? '使用中':'使用'}}
                                                </p>
                                            </div>
                                        <!-- </router-link> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="flex_ali">
            <div class="anchor_btn" @click="anchor_audio.play(item2.zbmusicurl)" v-if="anchor_audio.audiourl !== item2.zbmusicurl" >
              <img src="../assets/images/play.png" />
              <span>试听</span>
            </div>
            <div class="anchor_btn anchor_btn2" @click="anchor_audio.play(item2.zbmusicurl)" v-else>
              <img src="../assets/images/pause.png" />
              <span>暂停</span>
            </div>
            <div class="anchor_btn anchor_btn1" @click="useAnchor(item2)">
              <img src="../assets/images/enit.png" />
              <span>使用</span>
            </div>
          </div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import PlayListAudio from "../utils/PlayListAudio.js";
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
export default {
    data() {
        return {
            // 模板样音播放器对象
            demo_audio: new PlayListAudio(),

            tabindex: 0, //tab选择索引
            anchor_audio: new PlayListAudio(),
        };
    },
    computed: {
        ...mapState(["reallist", "allrealist","real_anchor","chose_music"]),
    },
    mounted() {
        this.getAnchorList();
        console.log(this.allrealist)
    },
    methods: {
        // 获取主播列表
        getAnchorList() {
            let self = this;
            if (self.$store.state.anchor_list.length !== 0) return;
            let url =
                self.$store.state.app_api +
                self.$store.state.app_url.qryttszhubov5;
            this.$request.postHttp({}, url, (decData) => {
                if (!self.$store.state.anchor.zbid)
                    self.$store.commit(
                        "setAnchor",
                        decData.model.defaultTtszhuboList[0]
                    );
                self.$store.commit(
                    "setAnchorList",
                    decData.model.ttsZhuboAllList
                );
            });
        },
        // 抛出背景蒙版点击事件
        clickMb() {
            this.$emit("mb");
        },
        // 抛出组件使用主播事件
        useAnchor(item,item3) {
            console.log(item)
            this.$store.commit("setRealAnchor", item);
            this.$store.commit("setChoseMusic",item3);
            this.$emit("user", item);
        },
        // 真人配音播放事件
        playReal(url) {
            // this.stopAllMusci();
            this.demo_audio.play(url);
        },
    },
    watch: {
        // 监听主播选择界面显示状态
        show_anchor: function (val) {
            // 界面隐藏是停止主播试听播放器
            if (!val) this.anchor_audio.stop();
        },
    },
};
</script>
<style scoped>
.anchor_btn2 {
    background-color: rgba(254, 186, 7, 0.15) !important;
}
.anchor_btn2 span {
    color: #74b9ff;
}
.anchor_btn1 {
    background-color: #74b9ff !important;
    margin-left: 16px;
}
.anchor_btn span {
    font-size: 12px;
}
.anchor_btn img {
    width: 14px;
    height: 14px;
    margin-right: 4px;
}
.case_btn {
    border-radius: 7px;
    width: 90px;
    text-align: center;
    height: 36px;
    line-height: 36px;
    background-color: rgb(236, 232, 232) !important;
}
.anchor_btn {
    cursor: pointer;
    width: 72px;
    height: 36px;
    background-color: #eee;
    border-radius: 6px;
    padding: 10px 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.anchor_desp {
    color: #999;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 20px;
}
.anchor_desp2 {
    width: 130px;
    overflow: hidden;
    color: #999;
    font-size: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.anchor_name {
    font-size: 18px;
}
.anchor_img {
    width: 60px;
    height: 60px;
    border-radius: 100%;
    background-color: #eee;
    margin: 16px;
}
.anchor_li {
    display: flex;
    flex-direction: column;
    width: 342px;
    height: 330px;
    /* height: 80px; */
    background: #f8f8f8;
    border-radius: 10px;
    /* display: flex; */
    /* align-items: center;
  justify-content: space-between; */
    margin-left: 16px;
    float: left;
    margin-bottom: 16px;
    /* padding: 10px 16px; */
}
.anchor_li:nth-child(3n+1) {
    margin-left: 0;
}
.anchor_listcon {
    width: 1116px;
    height: 700px;
    background: #ffffff;
    border-radius: 10px;
    margin-left: 24px;
    padding: 24px;
    overflow-y: scroll;
}
.anchor_listcon::-webkit-scrollbar {
    width: 10px; /*滚动条宽度*/
    height: 10px; /*滚动条高度*/
}
/*定义滚动条轨道 内阴影+圆角*/
.anchor_listcon::-webkit-scrollbar-track {
    border-radius: 5px; /*滚动条的背景区域的圆角*/
}
/*定义滑块 内阴影+圆角*/
.anchor_listcon::-webkit-scrollbar-thumb {
    border-radius: 5px; /*滚动条的圆角*/
    background-color: rgba(153, 153, 153, 0.4);
}
.anchor_tabact {
    background-color: #74b9ff;
}
.anchor_tabli {
    width: 100%;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    cursor: pointer;
}
.anchor_tab {
    width: 180px;
    border-radius: 10px;
    overflow: hidden;
    background-color: #fff;
    height: 100%;
    overflow-y: scroll;
}
.anchor_tab::-webkit-scrollbar {
    width: 0; /*滚动条宽度*/
    height: 0; /*滚动条高度*/
}
/*定义滚动条轨道 内阴影+圆角*/
.anchor_tab::-webkit-scrollbar-track {
    border-radius: 5px; /*滚动条的背景区域的圆角*/
}
/*定义滑块 内阴影+圆角*/
.anchor_tab::-webkit-scrollbar-thumb {
    border-radius: 5px; /*滚动条的圆角*/
    background-color: rgba(153, 153, 153, 0.4);
}
.anchor_mian {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: space-around;
}
.anchor_con {
    display: flex;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
}
.anchor_mian_mb {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
}
.fontCR {
    color: #de1c31ff;
}
.flexDR {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.marR {
    margin-right: 10px;
}
.flex_ali {
    border-bottom: 1px solid #eee;
}
.flex_sb{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.outer {
    width: 100%;
    height: 237px;
    overflow: scroll;
    position: relative;
    overflow: hidden;
    overflow-y: auto
}
.online{
    width: 48px;
    text-align: center;
    height: 21px;
    line-height: 21px;
    font-size: 12px;
    border-radius: 5px;
    background-color: rgba(116,185,255,.2);
    color: #74b9ff;
}
.choseAnchor{
    border: 2px solid #74b9ff;
}
.choseBtn{
    background-color: #74b9ff;
}
</style>



// WEBPACK FOOTER //
// src/components/realAnchor.vue